import React from 'react';
import Switch from '../../../core/components/Switch';
import { SwitchItemContainer, SwitchItemDescription, SwitchItemName, SwitchItemPrompt, } from './styles';
import { useSDK } from '../../../core/hooks/useSDK';
const SwitchItem = ({ onChange, value, title, prompt }) => {
    const { connected } = useSDK();
    return (React.createElement(SwitchItemContainer, null,
        React.createElement(SwitchItemDescription, null,
            React.createElement(SwitchItemName, null, title),
            React.createElement(SwitchItemPrompt, null, prompt)),
        React.createElement(Switch, { disabled: !connected, value: value, "data-qa-anchor": "community-permissions", onChange: onChange })));
};
export default SwitchItem;
//# sourceMappingURL=SwitchItem.js.map